module.exports = __webpack_public_path__ + "img/about-01.ae2e62f5.webp";